module.exports = __webpack_public_path__ + "img/Frame-15.a8566346.svg";